import type { ThemeMode } from '../../hooks/useTheme.ts';

const OPTIONS: { value: ThemeMode; label: string; hint: string }[] = [
  { value: 'system', label: 'Auto', hint: 'Follow system theme' },
  { value: 'light', label: 'Light', hint: 'Light theme' },
  { value: 'dark', label: 'Dark', hint: 'Dark theme' },
];

/** Three-way theme control. Keyboard-operable; the active option is announced
 *  via aria-pressed. */
export function ThemeToggle({
  mode,
  onChange,
}: {
  mode: ThemeMode;
  onChange: (m: ThemeMode) => void;
}) {
  return (
    <div className="segmented" role="group" aria-label="Theme">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className="segmented__btn"
          aria-pressed={mode === opt.value}
          title={opt.hint}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
